import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const STORAGE_KEY = "aurex_banner_dismiss";

export default function Banner() {
  const { content } = useSite();
  const b = content?.banner;
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!b?.dismissible) return;
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && saved === (b.message || "")) setDismissed(true);
    } catch { /* ignore */ }
  }, [b?.dismissible, b?.message]);

  const close = () => {
    setDismissed(true);
    try { localStorage.setItem(STORAGE_KEY, b?.message || ""); } catch { /* ignore */ }
  };

  const show = !!(b && b.enabled && b.message && !dismissed);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          data-testid="site-banner"
          className="sticky top-0 z-[55] w-full overflow-hidden bg-[color:var(--aurex-accent)] text-[color:var(--aurex-on-accent)]"
        >
          <div className="mx-auto flex max-w-[1400px] items-center justify-center gap-3 px-6 py-2.5 text-sm font-medium md:px-10">
            <span className="text-center leading-snug">{b.message}</span>
            {b.link_text && b.link_target && (
              <a
                href={b.link_target}
                target={b.link_target.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                data-testid="banner-link"
                className="inline-flex shrink-0 items-center gap-1 rounded-full bg-black/20 px-3 py-1 text-xs font-semibold transition-colors hover:bg-black/30"
              >
                {b.link_text} <ArrowUpRight size={13} />
              </a>
            )}
            {b.dismissible && (
              <button
                type="button"
                data-testid="banner-close"
                onClick={close}
                aria-label="Cerrar aviso"
                className="ml-auto flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-black/20"
              >
                <X size={14} />
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
